import { ErrorMarkup } from 'modules/error';
import { isEmpty } from '@iterable/utils';
import { SENDING_PLATFORMS_PAGE_TEXT as TEXT } from '../../constants';
import {
  SendingPlatformsQueryContextProvider,
  useSendingPlatformsQueryContext,
} from '../../contexts';
import {
  Container,
  PageContentsWrapper,
  PageHeaderWrapper,
  PageMainHeader,
} from './SendingPlatformsIndexPage.styled';
import { ConnectedPlatformsSection } from './ConnectedPlatformsSection';
import { UnconnectedPlatformsSection } from './UnconnectedPlatformsSection';

export const SendingPlatforms = () => {
  const { hasError, espAccountsBySendingPlatform } = useSendingPlatformsQueryContext();
  if (hasError && isEmpty(espAccountsBySendingPlatform)) {
    return <ErrorMarkup id="sending-platforms-error-page" />;
  }

  return (
    <>
      <PageHeaderWrapper id="page-header-container" data-test="sending-platforms-index-header">
        <Container>
          <PageMainHeader>{TEXT.PAGE_HEADER}</PageMainHeader>
        </Container>
      </PageHeaderWrapper>
      <PageContentsWrapper id="accounts-container">
        <Container>
          <ConnectedPlatformsSection />
          <UnconnectedPlatformsSection />
        </Container>
      </PageContentsWrapper>
    </>
  );
};

export const SendingPlatformsIndexPage = () => (
  <SendingPlatformsQueryContextProvider>
    <SendingPlatforms />
  </SendingPlatformsQueryContextProvider>
);
